import * as types from "../actionTypes";
import * as eventTypes from "../eventTypes";
import initialState from "reducers/initialState";
import { CombineKeys } from "utils/functions";

export default function incomeDataReducer(state = initialState.currentOffer.clientIncomeData, action) {
  switch (action.type) {
    case types.LOAD_OFFER_PARTNER_INCOME_DATA_SUCCEEDED: {
      const { partnerIncomeData } = action.payload;
      const { partnerId, incomeTypeId } = partnerIncomeData;
      const key = CombineKeys(partnerId, incomeTypeId);
      const incomeData = {
        ...state.incomeData,
        [key]: {
          isLoaded: true,
          isValid: true,
          saving: false
        }
      };

      return {
        ...state,
        incomeData
      };
    }

    case types.UPDATE_OFFER_PARTNER_SALARY_DATA_STARTED:
    case types.UPDATE_OFFER_PARTNER_INCOME_DATA_STARTED: {
      const { partnerId, incomeTypeId } = action.payload.data;
      const key = CombineKeys(partnerId, incomeTypeId);
      const existing = state.incomeData[key];

      return {
        ...state,
        incomeData: {
          ...state.incomeData,
          [key]: {
            ...existing,
            saving: true
          }
        }
      };
    }

    case types.UPDATE_OFFER_PARTNER_SALARY_DATA_SUCCEEDED:
    case types.UPDATE_OFFER_PARTNER_INCOME_DATA_SUCCEEDED: {
      const { partnerId, incomeTypeId } = action.payload.data;
      const key = CombineKeys(partnerId, incomeTypeId);
      const existing = state.incomeData[key];

      return {
        ...state,
        incomeData: {
          ...state.incomeData,
          [key]: {
            ...existing,
            saving: false,
            isValid: true,
            isLoaded: true
          }
        }
      };
    }

    case types.UPDATE_OFFER_PARTNER_SALARY_DATA_FAILED:
    case types.UPDATE_OFFER_PARTNER_INCOME_DATA_FAILED: {
      const { partnerId, incomeTypeId } = action.payload.data;
      const key = CombineKeys(partnerId, incomeTypeId);
      const existing = state.incomeData[key];

      return {
        ...state,
        incomeData: {
          ...state.incomeData,
          [key]: {
            ...existing,
            saving: false
          }
        }
      };
    }

    case eventTypes.OFFER_PARTNER_INCOME_DATA_INVALIDATED:
    case eventTypes.OFFER_PARTNER_SALARY_DATA_INVALIDATED: {
      const { partnerId, incomeTypeId } = action.event.eventBody;
      const key = CombineKeys(partnerId, incomeTypeId);
      const incomeData = {
        ...state.incomeData,
        [key]: {
          isLoaded: false,
          isValid: false,
          saving: false
        }
      };

      return {
        ...state,
        incomeData
      };
    }

    default:
      return state;
  }
}
